import React from "react";
import { useTranslation } from "react-i18next";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

interface FormTabsProps {
  tab: 'userDetails' | 'properties';
  add: boolean;
  onTabChange: (e: any, value: 'userDetails' | 'properties') => void;
}

const FormTabs: React.FC<FormTabsProps> = ({ tab, add, onTabChange }) => {
  const { t } = useTranslation()

  return (
    <div className="card-header overflow-hidden no-padding">
      <Tabs value={tab} onChange={onTabChange} textColor='primary'>
        <Tab value="userDetails" label={t("users.addEdit.pageTexts.form.tabs.userDetails")} />
        { !add && <Tab value="properties" label={t("users.addEdit.pageTexts.form.tabs.properties")} /> }
      </Tabs>
    </div>
  );
};

export default FormTabs;